"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var hooks_1 = require("../../hooks");
var Tab = function (_a) {
    var action = _a.action, active = _a.active, className = _a.className, disabled = _a.disabled, onFocus = _a.onFocus, onBlur = _a.onBlur, props = __rest(_a, ["action", "active", "className", "disabled", "onFocus", "onBlur"]);
    var TabElement = 'span';
    var itemRef = react_1.default.useRef(null);
    var _b = hooks_1.useFocusVisible(itemRef, onBlur, onFocus), isFocusVisible = _b.isFocusVisible, focusFunction = _b.focusFunction, blurFunction = _b.blurFunction;
    if (props.href)
        TabElement = 'a';
    var TabClasses = classnames_1.default('Tab', className, {
        'Tab--active': active,
        'Tab--inactive': !active,
        'Tab--disabled': disabled,
        'Tab--focus-visible': isFocusVisible,
    });
    return (react_1.default.createElement(TabElement, __assign({ role: "tab", ref: itemRef, tabIndex: disabled ? undefined : 0, "aria-current": active ? 'page' : false, className: TabClasses, onFocus: focusFunction, onBlur: blurFunction, "aria-disabled": props.disabled }, props)));
};
exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map